module.exports = __webpack_public_path__ + "static/media/accesories.2c98c63a.png";